export default __webpack_public_path__ + "static/media/grand-road-tashkent-logo.486b212a.png";